<template>
  <div>
    <!-- Table Container Card -->
    <b-overlay :show="overlay">
      <b-card no-body class="mb-0">
        <div class="m-2">
          <b-row>
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>Mostrar</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>entradas</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end actions-wrapper">
                <b-input-group>
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por nome ou tabela pai..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-button variant="primary" @click="resetFormData" v-b-modal.modal-add-tb-extensao>
                  <div class="d-flex" style="gap: 5px">
                    <iconfy icon="mdi:plus" />
                    <span class="">Tabela Extensão</span>
                  </div>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table ref="refUserListTable" class="position-relative" :items="fetchExtensaos" responsive
          :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
          empty-text="Nenhum registro encontrado" :sort-desc.sync="isSortDirDesc">
          <template #cell(created_at)="data">
            <div>
              <span>{{ formatDate(data.item.created_at) }}</span>
            </div>

          </template>

          <template #cell(actions)="data">
            <div>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" title="Editar" variant="gradient-primary" class="btn-icon mr-1"
                @click="openEditModal(data.item)">
                <feather-icon icon="EditIcon" />
              </b-button>

              <b-button variant="gradient-danger" title="Deletar" class="btn-icon" @click="showModalDeleteExtensao(data.item.id)">
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }}
                entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <modal-confirmation v-model="isDeleteModal" id-modal="modal-delete-tb-extensao" title="Deletar Extensao"
          message="Tem certeza que deseja deletar?" btn-cancel-label="Cancelar" btn-ok-label="Sim" @ok="removeExtensao"
          @cancel="isDeleteModal = false" />
      </b-card>
    </b-overlay>

    <ModalAdd idModal="modal-add-tb-extensao" titleModal="Criar Tabela Extensão" :labelBtnOk="'Adicionar'"
      v-model="dataTbExtensao" @ok="create($event)" @hidden="resetFormData()" />
    <ModalAtt idModal="modal-att-tb-extensao" titleModal="Atualizar Tabela Extensão" :labelBtnOk="'Atualizar'"
      v-model="dataTbExtensao" @ok="handleUpdate" @cancel="resetFormData()" />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BSidebar, VBModal,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import store from '@/store';
import { ref, onUnmounted } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
// import ExtensaoListFilters from './TbExtensaoListFilters.vue'
import Notifier from '@/libs/Notifier';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import tbExtensaoStoreModule from '@/views/app/tb-extensao/tbExtensaoStoreModule';
import useExtensaosList from './useTbExtensaoList';
import ModalAdd from './ModalAdd.vue';
import ModalAtt from './ModalAtt.vue';

export default {
  components: {
    ModalConfirmation,
    // ExtensaoListFilters,
    ModalAdd,
    ModalAtt,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSidebar,
    Notifier,

    vSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      dataTbExtensao: {
        nome_tabela: '',
        tabela_extensao: '',
        uuid_cliente: '23e3b686-b8ac-4bc9-8fb3-5181da210fbc',
      },
      searchInputValue: '',
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return '';

      const dateObj = new Date(date);

      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();

      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');
      const seconds = String(dateObj.getSeconds()).padStart(2, '0');

      return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    },
    resetFormData() {
      console.log('resetFormData');
      this.dataTbExtensao = {
        nome_tabela: '',
        tabela_extensao: '',
        uuid_cliente: '23e3b686-b8ac-4bc9-8fb3-5181da210fbc',
      };
    },
    openEditModal(data) {
      this.dataTbExtensao = { ...data };
      this.$bvModal.show('modal-att-tb-extensao');
    },
    handleUpdate(formData) {
      this.Updated(formData);
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const notify = new Notifier();
    const USER_APP_STORE_MODULE_NAME = 'app-extensao';
    const isDeleteModal = ref(false);
    const idExtensao = ref(null);
    const dataTbExtensao = ref({
      nome_tabela: '',
      tabela_extensao: '',
      uuid_cliente: '23e3b686-b8ac-4bc9-8fb3-5181da210fbc',
    });
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, tbExtensaoStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    // const isAddNewExtensaoSidebarActive = ref(false)

    const showModalDeleteExtensao = (id) => {
      idExtensao.value = id;
      isDeleteModal.value = true;
    };

    const removeExtensao = (id) => {
      isDeleteModal.value = false;
      store.dispatch('app-extensao/removeExtensao', idExtensao.value)
        .then(() => {
          refetchData();
          notify.success('Excluido com sucesso');
        }).catch(() => {
          notify.error('Erro ao excluir');
        });
    };

    const {
      fetchExtensaos,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      overlay,
      create,
      Updated,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useExtensaosList();

    return {

      // Sidebar
      // isAddNewExtensaoSidebarActive,
      isDeleteModal,
      idExtensao,
      showModalDeleteExtensao,
      fetchExtensaos,
      removeExtensao,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      overlay,
      create,
      Updated,
      dataTbExtensao,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.actions-wrapper {
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .actions-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .actions-wrapper .input-group,
  .actions-wrapper .btn {
    width: 100%;
  }

  .actions-wrapper .btn {
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
